import React from 'react';

import MobileOnly from 'components/consumer/MobileOnly';
import MobileModal from 'components/consumer/MobileModal';
import CtaButton from 'components/essentials/Cta/CtaButton';

import MobileProductFilters from './MobileProductFilters';
import ProductClearAllFiltersButton from './ProductClearAllFiltersButton';

const MobileProductFiltersModal = ({
  isOpen,
  onClose,
  productsCount,
  items,
  refine,
  canClear,
  clearRefinement,
}) => {
  const activeFilterCount = items.filter(item => item.isRefined).length;

  return (
    <MobileOnly>
      <div className="md:hidden">
        <MobileModal
          enableHashHistory={false}
          headerRight={
            <ProductClearAllFiltersButton
              canClear={canClear}
              clearRefinement={clearRefinement}
            />
          }
          isFullHeight
          isOpen={isOpen}
          onClose={onClose}
          stickyFooter={
            <CtaButton block onClick={onClose}>
              Done ({productsCount || 0} result{productsCount === 1 ? '' : 's'})
            </CtaButton>
          }
          title={
            activeFilterCount > 0 ? `Filters (${activeFilterCount})` : 'Filters'
          }
        >
          <MobileProductFilters items={items} refine={refine} />
        </MobileModal>
      </div>
    </MobileOnly>
  );
};

export default MobileProductFiltersModal;
